<!-- @format -->

@if (validationErrorDetails.length > 0) {
  <sis-contextual-notification variant="danger">
    <div sisAutofocus [id]="id" tabindex="-1" aria-live="assertive">
      @if (description) {
        <div class="row">
          <div class="col-12">
            <p>{{ description }}</p>
          </div>
        </div>
      }
      <div class="row">
        <div class="col-12">
          <ul class="error-list">
            @for (error of validationErrorDetails; track error) {
              <li class="error-list__item">
                <sis-button [link]="true" (clicked)="focusOnElement(error.inputId)">{{ error.inputLabel }}</sis-button>
              </li>
            }
          </ul>
        </div>
      </div>
    </div>
  </sis-contextual-notification>
}
